import React from 'react';
import { FormInput } from 'components/form';
import { Box, Button, LinearProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

interface Props {
  externalDealId: string;
  doesUserHaveAccessToDealSync: boolean;
  onExternalDealIdChange: (id: string) => void;
  handleFillInDealInfo: (id: string) => void;
  isGettingDealInfoFromFromExternalDms: boolean;
}

export const SyncDealInfoOnStartDeal = ({
  externalDealId,
  doesUserHaveAccessToDealSync,
  handleFillInDealInfo,
  onExternalDealIdChange,
  isGettingDealInfoFromFromExternalDms,
}: Props) => {
  const classes = useStyles();

  return (
    <RenderWithCondition condition={doesUserHaveAccessToDealSync}>
      <Box className={classes.sync}>
        <FormInput value={externalDealId} placeholder="External Deal Number" onChange={onExternalDealIdChange} />

        {isGettingDealInfoFromFromExternalDms && (
          <div>
            <LinearProgress style={{ width: '20%' }} />
          </div>
        )}

        {!isGettingDealInfoFromFromExternalDms && (
          <Box>
            <Button variant="outlined" onClick={() => handleFillInDealInfo(externalDealId)}>
              Fill Deal Information
            </Button>
          </Box>
        )}
      </Box>
    </RenderWithCondition>
  );
};

const useStyles = makeStyles({
  sync: {
    gap: '1rem',
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '15rem auto',
  },
});
